import { METHOD } from './method'

export const API_STORE = {
    LIST: {
        api: '/v1/dashboard-admin/store',
        method: METHOD.GET,
    },
    DELETE: {
        api: '/v1/dashboard-admin/store',
        method: METHOD.DELETE,
    },
    CITY_LIST: {
        api: '/v1/dashboard-admin/store/city',
        method: METHOD.GET,
    },
    CREATE: {
        api: '/v1/dashboard-admin/store',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/store',
        method: METHOD.PUT,
    },
    URL_BANNER: {
        api: '/v1/dashboard-admin/store/banner/storage-url/attachment',
        method: METHOD.POST,
    },
    DETAIL_BANNER: {
        api: '/v1/dashboard-admin/store/banner',
        method: METHOD.GET,
    },
    UPDATE_BANNER: {
        api: '/v1/dashboard-admin/store/banner',
        method: METHOD.PUT,
    },
}
